"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConceptTemplate = void 0;
const types_1 = require("../main/types");
class ConceptTemplate extends types_1.ConceptTemplateType {
}
exports.ConceptTemplate = ConceptTemplate;
ConceptTemplate.converter = {
    toFirestore(data) {
        return {
            moduleId: data.moduleId,
            title: data.title,
            description: data.description,
            cardIds: data.cardIds,
            cardCount: data.cardIds.length,
            conceptMaterialId: data.conceptMaterialId
        };
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const id = snapshot.id;
        const moduleId = documentData.moduleId;
        const title = documentData.title;
        const description = documentData.description;
        const cardIds = documentData.cardIds;
        const data = new ConceptTemplate(moduleId, title, description, cardIds);
        data.id = id;
        data.conceptMaterialId = documentData.conceptMaterialId;
        return data;
    }
};
